import React from 'react';
import cls from 'classnames';
import Button from '../Button';
import CloseImg from './assets/close.png';
import { IModal } from './interface';
// eslint-disable-next-line import/no-cycle
import Alert from './alert';
// eslint-disable-next-line import/no-cycle
import Info from './info';
import styles from './style.module.scss';

const Modal: IModal = ({
  footers,
  visible,
  onClose,
  title,
  closable = true,
  maskClosable = false,
  children,
  className,
  closeClassName,
  footersClassName,
  contentClassName,
  titleClassName,
  closeType = true,
}) => {
  return (
    <div
      className={cls(styles.mask, {
        [styles.hide]: !visible,
      })}
      onClick={() => {
        if (maskClosable) {
          onClose?.();
        }
      }}
    >
      <div
        className={cls(styles.container, className)}
        onClick={(e) => {
          if (maskClosable) {
            e.stopPropagation();
          }
        }}
      >
        {closable && (
          <div className={cls(styles.close, closeClassName)} onClick={onClose}>
            {closeType ? (
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.5 24.5C19.1274 24.5 24.5 19.1274 24.5 12.5C24.5 5.87258 19.1274 0.5 12.5 0.5C5.87258 0.5 0.5 5.87258 0.5 12.5C0.5 19.1274 5.87258 24.5 12.5 24.5Z"
                  fill="#F3F3F3"
                />
                <path
                  d="M8.9327 16.1004L16.0984 8.90039M16.0642 16.1004L8.89844 8.90039"
                  stroke="#1F1D1C"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <img src={CloseImg.src} alt="CloseImg" className={styles.closeImg} />
            )}
          </div>
        )}

        {title && <div className={cls(styles.title, titleClassName)}>{title}</div>}
        <div className={cls(styles.content, contentClassName)}>{children}</div>
        {footers && (
          <div className={cls(styles.footer, footersClassName)}>
            {footers.map(({ type, disable, className, content, ...restProps }, index) => {
              return (
                <Button
                  className={cls(styles.button, className)}
                  styleType={type}
                  key={index}
                  disabled={disable}
                  {...restProps}
                >
                  {content}
                </Button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

Modal.alert = (params) => {
  return new Alert(params);
};

Modal.info = (params) => {
  return new Info(params);
};

export default Modal;
